import SettingList from './SettingList'
import * as React from 'react'
import { IServiceProgramObject } from '../../types/service-program'
import PreloaderCircle from '../ui/PreloaderCircle'
import ErrorMessage from '../ui/ErrorMessage'

interface IServiceProgramListProps {
  items: IServiceProgramObject[]
  fetching: boolean
  fetchingError: string
  baseUrl: string
  onComponentMount: () => void
}

class ServiceProgramList extends React.Component<IServiceProgramListProps> {
  public componentDidMount() {
    this.props.onComponentMount()
  }

  public render() {
    const { items, fetching, fetchingError } = this.props
    return (
      <div>
        <ErrorMessage visible={!!fetchingError}>{fetchingError}</ErrorMessage>

        <p className='h5 bold pl2 font-black'>Service Programs List</p>

        <div className='pl3 pr3 col-4'>
          <PreloaderCircle loading={fetching} />
          <SettingList baseUrl={this.props.baseUrl} settings={items.map(it => ({ id: it.id, label: it.name }))} />
        </div>
      </div>
    )
  }
}

export default ServiceProgramList



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceProgramList.tsx